export default __webpack_public_path__ + "static/media/go_back.f2ce793e.svg";